module.exports = __webpack_public_path__ + "img/infura.5e85646d.svg";